let OccasionId = 22319429;
let Occasion = [
  {
    value: "",
    title: " - "
  },
  {
    value: "corporate",
    title: "Corporate Event"
  },
  {
    value: "gifts_favors",
    title: "Personal Gifts & Favors"
  },
  {
    value: "weddings",
    title: "Weddings"
  },

  {
    value: "celebration_cakes",
    title: "Celebration Cakes"
  },
  {
    value: "others",
    title: "Others"
  }
];

let SERVER_API = "https://freedom-bakery-custom-shipping-app.freedombakery.com";
    // SERVER_API= "http://localhost:3000"; 
 
$(document).ready(function () {
  let options = {
    acceptedFiles:
      ".tif,.bmp,.txt,.rtf,.doc,.docx,.xls,.xlsx,.csv,.xlsb,.ppt,.pptx,.xps,.psd,.pdd,.psb,.rle,.dib,.gif,.dcm,.dc3,.dic,.eps,.iff,.tdi,.jpg,.jpeg,.jpe,.jpf,.jpx,.jp2,.j2c,.j2k,.jpc,.pcs,.pdf,.pdp,.raw,.pxr,.png,.pbm,.pgm,.ppm,.pnm,.pfm,.pam,.sct,.tga,.vda,.icb,.vst,.ai,.svg,.svgz,.vst,.pns,.epsf,.ps,.cdr,.cgm,.dwg,.dxf,.sket,.ait,.idea,.heic,.dng,.raw,.m4a,.ogg,.wav,.mp3,.aac,.flac,.wma,.aiff,.aif,.snd,.cel,.cda,.voc,.vox,.dwd,.au,.pcm,.smp,.wmp,.rmi,.mid,.ses,.sesx,.alac",
    timeout: 0, 
 
    addRemoveLinks: true,
    maxFiles: 5,
    url: SERVER_API + "/api/new/upload-ticket-attachment-freshdesk", 
      
    init: function () {
      this.on("addedfile", function (file) {
        $('form.single-form button[type="submit"]').attr(
          "disabled",
          "disabled"
        );
      });
      this.on("queuecomplete", function (file) {
        $('form.single-form button[type="submit"]').removeAttr("disabled");
      });
    }
  };
  window.SupportImageDropZone = new Dropzone("#support-image-upload", options);
  window.QuoteImageDropZone = new Dropzone("#qoute-image-upload", options);

  $(".close-form,.simple-close,.bg-wrapper").click(function (e) {
    $(".zendesk-form-wrapper").removeClass("active");
    $("body").removeClass("zendesk-form-active");
    $("body").removeClass("quote-form-active");
  
    $(
      ".support-chat-wrapper button,.support-chat-wrapper-mobile button"
    ).removeClass("selected-button");
    if (location.href.includes("frequently-asked-questions")) {
      $(".faq-support").addClass("selected-button");
    } else {
      $(".zendesk-support").addClass("selected-button");
    }
    $(".bg-wrapper").removeClass("active");
  });

  $(".zendesk-support").click(function (e) {
    $(
      ".support-chat-wrapper button,.support-chat-wrapper-mobile button"
    ).removeClass("selected-button");
    $(".zendesk-support").addClass("selected-button");
    $(".single-form").addClass("hidden");
    $(".support-form").removeClass("hidden");
    $(".zendesk-form-wrapper").addClass("active");
    $(".bg-wrapper").addClass("active");
     
    $("body").addClass("zendesk-form-active");


    $(".date-picker-field input").datepicker({
      startDate: moment()._d,
      autoHide: true
    });
  });
  $(".quote-support").click(function (e) {
    $("body").addClass("quote-form-active");

    $(
      ".support-chat-wrapper button,.support-chat-wrapper-mobile button"
    ).removeClass("selected-button");
    $(".quote-support").addClass("selected-button");
    $(".single-form").addClass("hidden");
    $(".quote-form").removeClass("hidden");
    $(".zendesk-form-wrapper").addClass("active");
    $(".bg-wrapper").addClass("active");
  });

  const generateField = ({
    id,
    name,
    label,
    inputType,
    fieldType,
    extraClass,
    options,
    placeholder,
    extra
  }) => {
    let input = "";
    if (fieldType == "select") {
      let select = $(`<select name="${name}" ></select>`);
      options.forEach(e => {
        select.append(`<option value="${e.value}">${e.title}</option>`);
      });
      input = select[0].outerHTML;
    } else if (fieldType == "textarea") {
      input = `<textarea  id="${name}-${id}" name="${name}" ${extra} ></textarea>`;
    } else {
      input = `<div><input placeholder="${placeholder ? placeholder : ""
        }" type="${inputType}" id="${name}-${id}" name="${name}" ${extra} /></div>`;
    }

    return `<div class="input-group-with-label ${extraClass}">
    <label for="${name}-${id}"> ${label}</label>
    ${input}
  </div>`;
  };
  const populateConditionalFields = function (value, selector) {
    $(selector).html("");
    let fields = "";

    let companyField = generateField({
      id: "c1",
      name: "company",
      label: "Company ",
      inputType: "text",
      extra: "required"
    });
    let eventField = generateField({
      id: "ev1",
      name: "event",
      label: "Event",
      inputType: "text",
      extra: ""
    });
    let eventDateField = generateField({
      id: "date1",
      name: "event_date",
      label: "Date Needed By ",
      inputType: "text",
      placeholder: "dd/mm/yyyy",
      extra: "",
      extraClass: "date-picker-field"
    });
    let productDescField = generateField({
      id: "pd-1",
      name: "product-description",
      label: "Product Interested",
      inputType: "text",
      extra: ""
    });
    let QuantityField = generateField({
      id: "qty-1",
      name: "quantity",
      label: "Quantity",
      inputType: "number",
      extra: ""
    });
    let TotalBudgetField = generateField({
      id: "tot-1",
      name: "totalbudget",
      label: "Total Budget (including shipping)",
      inputType: "text",
      extra: ""
    });
    let ShiptoZipField = generateField({
      id: "ship-to-zip-1",
      name: "zipcode",
      label: "Ship to Zip Code",
      inputType: "text",
      extra: ""
    });
    let ShippingRequirementsField = generateField({
      id: "shipping-requirement",
      name: "shipping-details",
      label: "Shipping requirement details",
      fieldType: "textarea",
      extra: ""
    });

    let MultiLocationField = generateField({
      id: "ml-1",
      name: "multilocation",
      label: "Multi location shipping?",
      fieldType: "select",
      options: [
        { value: "", title: " - " },
        { value: "yes", title: "Yes" },
        { value: "no", title: "No" }
      ],
      extra: ""
    });

    let MultiLocationWrapper = $(`<div class="multi-location-wrapper"></div>`);
    let locField = $(MultiLocationField).on("change", "select", function (e) {
      $(".location-extra-options").html("");
      if (this.value == "yes") {
        $(".location-extra-options").append(ShippingRequirementsField);
      } else if (this.value == "no") {
        $(".location-extra-options").append(ShiptoZipField);
      }
    });
    MultiLocationWrapper.append(locField);
    MultiLocationWrapper.append('<div class="location-extra-options"></div>');

    let DetailsField = generateField({
      id: "det-1",
      name: "details",
      label: "Details",
      fieldType: "textarea",
      extra: "required"  
    });  

    //   Special Wedding Fields    
    let WeddingDateField = generateField({
      id: "date1",
      name: "event_date",
      label: "Wedding Date", 
      inputType: "text",
      extra: "",
      extraClass: "date-picker-field"
    });
    let GuestCountField = generateField({
      id: "guest-count-1",
      name: "guest-count",
      label: "Expected Guest Count ",
      inputType: "number",
      extra: ""
    });
    let ReceptionAddress = generateField({
      id: "resp-address-1",
      name: "reception-address",
      label: "Reception Venue",
      inputType: "text",
      extra: ""
    });

    //

    switch (value) {
      case "corporate":
        fields = $("<div></div>");
        fields.append(eventField);
        fields.append(eventDateField);
        fields.append(productDescField);
        fields.append(QuantityField);
        fields.append(TotalBudgetField);
        fields.append(MultiLocationWrapper);
        fields.append(DetailsField);
        break;

      case "gifts_favors":
        fields = `
                ${eventField}
                ${eventDateField}
                ${productDescField}
                ${QuantityField}
                ${TotalBudgetField}
                ${ShiptoZipField}
                ${DetailsField}`;

        break;
      case "weddings":
        fields = `
                ${WeddingDateField}
                ${GuestCountField}
                ${ReceptionAddress}
                ${DetailsField}`;

        break;
      case "celebration_cakes":
        fields = `
                ${eventField} 
                ${eventDateField.replace("Date Needed By", "Event Date")}
                ${TotalBudgetField}
                ${DetailsField}`;

        break;
      case "others":
        fields = `
                ${eventField} 
                ${eventDateField.replace("Date Needed By", "Event Date")}
                ${TotalBudgetField}
                ${DetailsField}`;

        break;
      default:
        break;
    }

    $(selector).html(fields);
    setTimeout(() => {
      $(".date-picker-field input").datepicker({ startDate: moment()._d });
    }, 10);
  };

  let inputGroupWrapper = $('<div class="input-group-with-label"></div>');
  inputGroupWrapper.append('<label for="subject"> Occasion &nbsp;</label>');

  let selectOccasion = $('<select name="occasion" ></select>');
  Occasion.forEach(e => {
    selectOccasion.append(`<option value="${e.value}">${e.title}</option>`);
  });
  selectOccasion.on("change", function (e, v) {
    populateConditionalFields(this.value, ".occasion-based-fields");
  });

  inputGroupWrapper.append(selectOccasion);
  inputGroupWrapper.append(`<div class="occasion-based-fields"></div>`);

  $(".quote-form").find(".extra-fields").html(inputGroupWrapper);

  function getFormData($form) {
    var unindexed_array = $form.serializeArray();
    var indexed_array = {};

    $.map(unindexed_array, function (n, i) {
      indexed_array[n["name"]] = n["value"];
    });

    return indexed_array;
  }
  $(".support-form").submit(function (e) {
    e.preventDefault();
    $(this).find("button").text("...").attr("disabled", "disabled");

    let data = getFormData($(this));
    let customs_fields = [
    {
    id: "cf_widget_location", // Widget Location 
    value: "Origin_Main_Widget"
    },
    {
      id: "cf_widget_type", // Widget Type 
      value: "Origin_Widget"
    } 
  ];
  if (data.occasion && data.occasion != "") {

      let occasionName = Occasion.find(e => e.value == data.occasion);
      let occasionTitle = occasionName ? occasionName.title : "";
        customs_fields.push({
          id: "cf_occasion",
          value:occasionTitle 
        }); 
    }  

    if (data.telephone && data.telephone != "") {
      customs_fields.push({
        id: "cf_phone_number",
        value: data.telephone
      });
    }
    if (data.event_date && data.event_date != "") {
      customs_fields.push({
        id: "cf_event_date",
        value: data.event_date
      });
    }
    let datacomments = data.comment;
    // replace all new lines with <br>
    datacomments = datacomments?.replace(/(?:\r\n|\r|\n)/g, '<br>');

    let formattedData = {
      email: data.email,
      name: data.name,
      subject: data.subject,
      comment: datacomments,
      customs_fields: customs_fields
    };
    let supportImages = [];
    SupportImageDropZone.files.forEach(f => {
      try {
        if (f.status == "success") {
          let r = JSON.parse(f.xhr.response);
          supportImages.push(r.file.path);
        } 
      } catch (e) { }
    });
    formattedData.uploads = supportImages;
    var settings = {
      url: SERVER_API + "/api/new/create-freshdesk-ticket",
      method: "POST",
      timeout: 0,
      headers: {
        Authorization:
          "Basic cGF1bEBmcmVlZG9tYmFrZXJ5LmNvbS90b2tlbjpkc0J2S3ZrOXdMZk5rVWVOdGhuMWQyNXFIa2hMMEx1Z1h0VEZONDEw",
        "Content-Type": "application/json"
      },
      data: JSON.stringify(formattedData)
    };

    $.ajax(settings).done(function (response) {
      /* Event snippet for Submit lead form conversion page */
      gtag('event', 'conversion', {'send_to': 'AW-860402960/UFCQCJ_E_IwcEJDqopoD'});
      $(".support-form")[0].reset();
      $(".support-form").find("button").text("Submit").removeAttr("disabled");
      $(".support-form").addClass("hidden");
      $(".form-confirmation").removeClass("hidden");
      window.SupportImageDropZone.removeAllFiles();
    });
  });
  $(".quote-form").submit(function (e) {
    e.preventDefault();
    $(this).find("button").text("...").attr("disabled", "disabled");

    let data = getFormData($(this));
    let customs_fields = [
      {
      id: "cf_widget_location", // Widget Location 
      value: "Origin_Main_Widget"
      },
      {
        id: "cf_widget_type", // Widget Type 
        value: "Origin_Quote_Widget"
      }  
    ];

    if (data.occasion && data.occasion != "") {

      let occasionName = Occasion.find(e => e.value == data.occasion);
      let occasionTitle = occasionName ? occasionName.title : "";
      customs_fields.push({
        id: "cf_occasion",
        value: occasionTitle
      }); 
    }
 
    if (data.telephone && data.telephone != "") {
      customs_fields.push({
        id:"cf_phone_number",
        value: data.telephone
      });
    }
    if (data.event_date && data.event_date != "") {
      customs_fields.push({
        id: "cf_event_date",
        value: data.event_date
      });
    }

    let AllComments = "";

    for (const [key, value] of Object.entries(data)) {
      if (
        key == "email" ||
        key == "name" ||
        key == "subject" ||
        key == "comment" ||
        key == "telephone" ||
        key == "event_date"
      ) {
      } else {

        let new_value = value?.replace(/(?:\r\n|\r|\n)/g, '<br>');
  
        AllComments += `${key.toUpperCase()} : ${new_value}<br>`;
      }
    }

    // AllComments+=`Comment:  ${data.comment}`;
    let subject = data.subject || data.event;
    if (data.occasion == "weddings") data.subject = "Wedding";

    subject = subject && subject != "" ? subject + " - [QUOTE]" : "[QUOTE]";
    let formattedData = {
      email: data.email,
      name: data.name,
      subject: subject,
      comment: AllComments,
      customs_fields: customs_fields
    };
    let QuoteImages = [];
    QuoteImageDropZone.files.forEach(f => {
      try {
        if (f.status == "success") {
          let r = JSON.parse(f.xhr.response);
          QuoteImages.push(r.file.path);
        } 
      } catch (e) { }
    });
    formattedData.uploads = QuoteImages;

    var settings = {
      url: SERVER_API+"/api/new/create-freshdesk-ticket", 
      method: "POST",
      timeout: 0,
      headers: {
        Authorization:
          "Basic cGF1bEBmcmVlZG9tYmFrZXJ5LmNvbS90b2tlbjpkc0J2S3ZrOXdMZk5rVWVOdGhuMWQyNXFIa2hMMEx1Z1h0VEZONDEw",
        "Content-Type": "application/json"
      },
      data: JSON.stringify(formattedData)
    };

    // console.log(formattedData);

    $.ajax(settings).done(function (response) {
      gtag('event', 'conversion', {'send_to': 'AW-860402960/lAOyCPG7yYwcEJDqopoD'});
      gtag('set', 'user_data', {'email': data.email,'phone_number': data.telephone || ''});
      $(".quote-form")[0].reset();
      $(".quote-form").find("button").text("Submit").removeAttr("disabled");
      $(".quote-form").addClass("hidden");
      $(".form-confirmation").removeClass("hidden");
      window.QuoteImageDropZone.removeAllFiles();
    });
  });

  $(document).on('click', 'a', function (e) {
    let link = $(this).attr('href');
    if (link && link.includes('#quote')) {
       
      let value = link.split('#quote_');

      value= value[value.length-1];
      // console.log(`quote-link`,value)
      openSupportModal(value) 
    } 

    if (link && (link.includes('#quote'))) {
      let value = link.split('#quote_');
      value= value[value.length-1];

      openSupportModal('.quote-support', value)
    } 
    if (link && (link.includes('#support'))) {
      let value = link.replace('#support_', '');
      value= value[value.length-1];

      openSupportModal('.zendesk-support', value)
    }


  }); 

  // open modal directly via link
  var current_hash = window.location.hash
  if (current_hash && (current_hash.includes('#quote'))) {
    let value = current_hash.replace('#quote_', '');
    openSupportModal('.quote-support', value)
  }
  if (current_hash && (current_hash.includes('#support'))) {
    let value = current_hash.replace('#support_', '');
    openSupportModal('.zendesk-support', value)
  }

  function openSupportModal(key, value) {
    $(key).click(); setTimeout(function () {
      $('select[name="occasion"]').val(value).change();
    }, 200);
  }
});
